const layout = () => import("../../internal/dashboard/layoutV2.vue");
const myBuys = () => import("./myBuysV2.vue");
const myBuyResume =() => import('./myBuyResume.vue')

const myBuysRoutes = {
  component: layout,
  children: [
    {
      path: "/myBuys",
      name: "myBuys",
      meta: {
        title: "myBuys",
        requiresAuth: true,
      },
      component: myBuys,
    },
    {
      path: "/myBuys/:id",
      name: "myBuyResume",
      meta: {
        title: "myBuyResume",
        requiresAuth: true,
      },
      component: myBuyResume,
    },
  ],
  
};

export default myBuysRoutes;